import {
    Checkbox, DataSourceExecutionEvent, DataSourceMode, DataSourceModeChangeEvent, Label, Layout, Tab,
    Textbox,
} from "@mcleod/components";
import { Alignment, StringUtil } from "@mcleod/core";
import { TransmissionStatusQuickInfo } from "./TransmissionStatusQuickInfo";
import { AutogenLayoutEdiDeclineCodeQuickInfo } from "./autogen/AutogenLayoutEdiDeclineCodeQuickInfo";
import { AutogenLayoutEdiOrderReply } from "./autogen/AutogenLayoutEdiOrderReply";



export class EdiOrderReply extends AutogenLayoutEdiOrderReply {

    override onLoad(): void {
        this.styleTab(this.tabErrors);
        this.setTransmissionStatusQuickInfo(this.checkboxReplyTransmitted);
        this.setTransmissionStatusQuickInfo(this.textboxReplyBatchId)
        this.setupReplyReasonQuickInfoSearch();
    }

    sourceErrorAfterExecution() {
        const replyErrorsArray = this.sourceEdiMapError.data.filter(error => error.data["transaction_type"] === "R");
        const replyErrorCount = replyErrorsArray.length;
        const replyWarningCount = replyErrorsArray.filter(error => error.data["error_type"] === "W").length;

        if(replyWarningCount >0 && replyWarningCount == replyErrorCount){
            this.tabErrors["countLabel"].color = "caution";
        }else if(replyErrorCount > 0){
            this.tabErrors["countLabel"].color = "error";
        }
        this.sourceEdiMapError.setRowsAndMode(DataSourceMode.NONE, (this.sourceEdiMapError.data.filter(error => error.data["transaction_type"] === "R")));
        this.tabErrors["countLabel"].text = this.sourceEdiMapError.data.length;
        if (this.sourceEdiMapError.data.length == 0) {
            this.tableErrors.visible = false;
        } else {
            this.tableErrors.visible = true;
        }
    }

    private setupReplyReasonQuickInfoSearch() {
        this.textboxReplyReason.quickInfoOverrideSearchMethod = async (layout: Layout, _keyValue: any) => {
            const activeRow = this.sourceViewEdiOrder.activeRow;
            const replyReason = activeRow.data["reply_reason"];
            if (!StringUtil.isEmptyString(replyReason)) {
                const body = {
                    partner_code: replyReason,
                    partner_id: activeRow.data["partner_id"],
                    version: activeRow.data["version"]
                };
                await (layout as AutogenLayoutEdiDeclineCodeQuickInfo).sourceEdiDeclineCodes?.search(body);
            }
        }
    }

    styleTab(tab: Tab) {
        if (tab.heading != null && tab.headingLabel != null) {
            tab.heading.color = "subtle.light";
            tab.headingLabel.setProps({ color: "default", fontBold: true, fillRow: false })
            if (tab["countLabel"] == null) {
                tab["countLabel"] = new Label({
                    fontBold: true, text: "0", fillRow: true,
                    color: "primary", rowBreak: false, marginLeft: 5
                });
                tab.heading.insert(tab["countLabel"], 1);
            }
        }
    }

    private setTransmissionStatusQuickInfo(component : Textbox | Checkbox){
        component.tooltipDynamicContent = async () => {
            if (this.mainDataSource?.activeRow.get("reply_batch_id") > "0") {
                const layout = await Layout.getLoadedLayout("lme/datafusion/TransmissionStatusQuickInfo") as TransmissionStatusQuickInfo;
                await layout.sourceEdiLog?.search({
                    direction: "O",
                    func_batch: this.mainDataSource.activeRow.get("reply_batch_id"),
                    batch: this.mainDataSource.activeRow.get("reply_batch_id"),
                    func_receiver_id: this.mainDataSource.activeRow.get("reply_partner_id"),
                    receiver_id: this.mainDataSource.activeRow.get("reply_altpartnerid"),
                    func_version: this.mainDataSource.activeRow.get("reply_version"),
                    transaction_type: 'R',
                    search_receiver_id: this.mainDataSource.activeRow.get("reply_partner_id")
                });
                return layout;
            }
            return null;
        }
    }
    /** This is an event handler for the afterExecution event of sourceViewEdiOrder.  */
    sourceViewEdiOrderAfterExecution(event: DataSourceExecutionEvent) {
        const row = this.mainDataSource.activeRow;
        const tenderDirection = row?.get("direction");
        this.checkboxReplyTransmitted.visible = ("I" == tenderDirection);
        if ("O" == tenderDirection) {
            this._setInboundReplyStatus();
            this.checkboxReplyTransmitted.visible = false;
            this.labelInboundReplyStatus.visible = true;
            this.labelAutoSendError.visible = false;
        } else {
            this.checkboxReplyTransmitted.visible = true;
            this.labelInboundReplyStatus.visible = false;
            const autoSendReply = row?.get("auto_send_reply") === "Y" ? true: false;
            if(autoSendReply) {
                const replyBatchId = row?.get("reply_batch_id");
                this.labelAutoSendError.visible = replyBatchId == "0" ? true : false;
            } else {
                this.labelAutoSendError.visible = false;
            }
        }
    }

    sourceViewEdiOrderAfterModeChange(event: DataSourceModeChangeEvent){
        if(event.newMode == DataSourceMode.SEARCH){  
           this.labelAutoSendError.visible = false;
        }
    }

    private _setInboundReplyStatus() {
        const replyReceived = this.mainDataSource.activeRow?.get("reply_received");
        const requiresReply = this.mainDataSource.activeRow?.get("requires_reply_outbound");
        let replyStatus = "Not Required";

        if (replyReceived == "Y") {
            replyStatus = "Processed";
        } else if (replyReceived == "N" && requiresReply == "Y") {
            replyStatus = "Not Received";
        } else if (requiresReply == "N") {
            replyStatus = "Not Required";
        }

        this.labelInboundReplyStatus.text = replyStatus;
    }
}
